import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector, } from 'react-redux';
import {useNavigate} from 'react-router-dom';

import Lottie from 'lottie-react';
import {Col, Row, Table, Button} from 'react-bootstrap';
import moment from 'moment-timezone';
import celebration from './lottie/celebration.json';

import {  certificationActions } from 'store/slices/certification/certificationSilce';

import {
	updateCertificationCompletedById, 
	updateCertificationStatusById,
	createEmetResult,
	generateEmetFinish
} from 'api/certifications/certifications';

import { fetchEmetResultByCertificationId } from 'api/certifications/emet/results';

import { 
	fetchEmetScores,
	fetchEmetScoreCertificationById
 } from 'api/certifications/emet/scores';

import { fetchUsers } from 'api/users/users';
import { fetchColleges } from 'api/colleges/colleges';

import { handleApiError } from 'utils';

import styles from 'assets/scss/wizard/emetSuccess.module.scss';


const EmetSuccess = ({certification}) => {
	const token = useSelector(state => state.authentication.user?.token);
	const username = useSelector(state => state.authentication.user?.username);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [emetScores, setEmetScores] = useState([]);
	const [emetScoreCert, setEmetScoreCert] = useState(0);

	useEffect(() => {
		if (token !== null && token !== undefined)
			loadEmetScores();
	}, [token]); 

	const loadEmetScores = async () => {
        try {
			const { data } = await fetchEmetScores(token);
			if(data?.status === 200) {
				setEmetScores(data.message);
				handleEmetScoreCertificationById(data.message);
			}
        } catch (error) {
            handleApiError(error);
        }
    };

	const handleEmetScoreCertificationById = async (emetScoresArray) => {
        try {
			const { data } = await fetchEmetScoreCertificationById(certification.id, token);
			if(data?.status === 200) {
				setEmetScoreCert(parseInt(data.total_correct_answers));	
				handleEmetResultByCertificationId(emetScoresArray, parseInt(data.total_correct_answers));
			}
        } catch (error) {
            handleApiError(error);
        }
    };

	const handleEmetResultByCertificationId = async (emetScoresArray, total_score) => {
		try {
			const { data } = await fetchEmetResultByCertificationId(certification.id, token);
			if (data?.status === 200) return;
		} catch (error) {
			if (error.response && error.response.status === 404) {
				handleUserByUsername(emetScoresArray, total_score);
			} else {
				handleApiError(error);
			}
		}
	};

	const handleUserByUsername = async (emetScoresArray, total_score) => {
		try {
			const { data } = await fetchUsers({ username: encodeURIComponent(username) }, token);
			handleEmetSuccess(data, emetScoresArray, total_score);
		} catch (error) {
			handleApiError(error);
		}
	};
	
	const handleEmetSuccess = async (user, emetScoresArray, total_score) => {
		try {
			const { data } = await fetchColleges({ id: certification.college_id }, token);
			const timeZone = moment.tz.guess();
			const readableDate = moment().tz(timeZone).format('YYYY-MM-DD HH:mm:ss')
			let rangeScore = emetScoresArray.find(range => total_score >= range.min && total_score <= range.max);
			
			let payload = {
				name: `${user.name} ${user.lastname}`,
				date: readableDate,
				score: total_score,
				title: rangeScore.title,
				email: user.email,  
				college: data.name
			}

			handleGenerateEmetFinish(payload, total_score);
        } catch (error) {
            handleApiError(error);
        }
    };

	const handleGenerateEmetFinish = async(data) => {
		try {
			const response = await generateEmetFinish(data, token);
			if(response.data.status === 200) {
				let data_1 = {
					certification_id: certification.id,
					total_score: data.score,
					total_percentage:   parseFloat(((data.score / 160) * 100).toFixed(2)),
					level: data.title
				}
				handleCreateEmetResult(data_1);
			} 
		} catch (error) {
			handleApiError(error);
		}
	}

	const handleCreateEmetResult = async(data_1) => {
		try {
			const { data } = await createEmetResult(data_1, token);
			if(data?.status == 201)
				handleUpdateCertificationStatusById();
		} catch (error) {
			handleApiError(error);
		}
	}

	const handleUpdateCertificationStatusById = async () => {
		try {
		    let data = { status: 2 }
		    await updateCertificationStatusById(certification.id, data, token);
		    handleUpdateCertificationCompletedById();
		} catch (error) {
		    handleApiError(error);
		}
	};

	const handleUpdateCertificationCompletedById = async () => {
		try {
			const timeZone = moment.tz.guess();
			const currentDate = moment().tz(timeZone).format('YYYY-MM-DD HH:mm:ss');
			let date = { completed_date: currentDate }
			await updateCertificationCompletedById(certification.id, date, token);
		} catch (error) {
			handleApiError(error);
		}
	};

	return (
		<>
			<Row className={styles.centerItems}>
				<Col className="text-center">
					<div className="wizard-lottie-wrapper">
						<div className="wizard-lottie mx-auto">
							<Lottie animationData={celebration} loop={true} />
						</div>
					</div>
					<h4 className="mb-1">You have finished!</h4>
					<p className="fs-0">You have successfully completed your test</p>
					<Button
						variant="primary"
						size="lg"
						onClick={() => {
							dispatch(certificationActions.resetCertification()); // Resetea el estado en Redux
							navigate('/'); // Redirige a la página principal
						}}
						className={`${styles.skipButton}`}>
						Finished
					</Button>
				</Col>
				<Col>
				<Table
						responsive
						className={`table-lg`}
						style={{
							fontSize: '0.9rem',
							marginTop: '5px',
							marginBottom: '5px',
						}}
					>
						<thead>
							<tr>
								<th style={{ padding: '15px' }}>Min</th>
								<th style={{ padding: '15px' }}>Max</th>
								<th style={{ padding: '15px' }}>Title</th>
								<th style={{ padding: '15px', textAlign: 'center' }}>Your score</th>
							</tr>
						</thead>
						<tbody>
							{emetScores.map((score, index) => {
								const isInRange =
									Number(emetScoreCert) >= Number(score.min) && Number(emetScoreCert) <= Number(score.max);
								return (
									<tr
										className={isInRange ? 'table-success' : 'table-secondary'}
										key={index}
										
									>
										<td
											style={{
												fontWeight: isInRange ? 'bold' : 'normal',
												padding: '15px',
												textAlign: 'right',
											}}
										>
											{score.min}
										</td>
										<td
											style={{
												fontWeight: isInRange ? 'bold' : 'normal',
												padding: '15px',
												textAlign: 'right',
											}}
										>
											{score.max}
										</td>
										<td
											style={{
												fontWeight: isInRange ? 'bold' : 'normal',
												padding: '15px',
											}}
										>
											{score.title}
										</td>
										<td
											style={{
												textAlign: 'center',
												fontWeight: isInRange ? 'bold' : 'normal',
												padding: '15px',
											}}
										>
											{isInRange ? emetScoreCert : ''}
										</td>
									</tr>
								);
							})}
						</tbody>
					</Table>
				</Col>
			</Row>
		</>
	);
};

export default EmetSuccess;
